import { NgIf, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { DonutChartComponent } from 'app/layout/common/donut-chart/donut-chart.component';

@Component({
  selector: 'app-kpi-widget',
  standalone: true,
    imports: [
        MatIcon,
        NgStyle,
        MatLabel,
        DonutChartComponent,
        NgIf,
        TranslocoPipe
    ],
  templateUrl: './kpi-widget.component.html',
  styleUrl: './kpi-widget.component.scss'
})
export class KpiWidgetComponent {
    @Input() icon: string;

    private _colors: string[];

    @Input()
    set colors(value: string[]) {
        this._colors = value;

        /**
         * This assumes the first color is the main one and the second
         * is the faded value, both are used in the donut to build a sort of color-palette theming.
         */
        this.mainColor = this._colors ? this._colors[1] : 'gray';
    }

    get colors(): string[] {
        return this._colors;
    }

    mainColor: string;

    @Input() title: string;
    @Input() value: number;
    @Input() total: number;

    data: number[];
}
